import React, { useEffect } from 'react'
import styled from 'styled-components';
// import PropTypes from 'prop-types';
import { ToastContainer, toast, Slide } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

import {isMobileOnly} from 'react-device-detect';

const ToastWrapper = styled.div`
/** Used to define container behavior: width, position: fixed etc... **/
.Toastify__toast-container {
  display: flex;
  justify-content: center;
  width: 100vw;
}

/** Used to define the position of the ToastContainer **/
.Toastify__toast-container--top-left {
}
.Toastify__toast-container--top-center {
}
.Toastify__toast-container--top-right {
}
.Toastify__toast-container--bottom-left {
}
.Toastify__toast-container--bottom-center {
  bottom:0;
}
.Toastify__toast-container--bottom-right {
}

/** Classes for the displayed toast **/
.Toastify__toast {
  width: ${isMobileOnly?"84vw":"800px"};
  ${isMobileOnly?`
  padding: 12px 20px;
  `:`
  padding: 16px 20px;
  `};
  
  border-radius: 4px;
  background-color: #323232;  
  
  min-height: 0;
  margin-bottom: ${isMobileOnly?"70px":"100px"};
  font-size: 14px;
  
  text-align: center;
  color: #fff;
}
.Toastify__toast--rtl {
}
.Toastify__toast--dark {
}
.Toastify__toast--default {
}
.Toastify__toast--info {
}
.Toastify__toast--success {
}
.Toastify__toast--warning {
}
.Toastify__toast--error {
}
.Toastify__toast-body {
  font-family:  Montserrat, 'Noto Sans KR', sans-serif;
  margin:0;
  //line-height: 1.5em;
  line-height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;

  white-space: pre-line;
}

/** Classes for the close button. Better use your own closeButton **/
.Toastify__close-button {
}
.Toastify__close-button--default {
}
.Toastify__close-button > svg {
}
.Toastify__close-button:hover, .Toastify__close-button:focus {
}

/** Classes for the progress bar **/
.Toastify__progress-bar {
}
.Toastify__progress-bar--animated {
}
.Toastify__progress-bar--controlled {
}
.Toastify__progress-bar--rtl {
}
.Toastify__progress-bar--default {
}
.Toastify__progress-bar--dark {
}
  `;

  const ToastWrapperLeft = styled.div`
  /** Used to define container behavior: width, position: fixed etc... **/
  .Toastify__toast-container {
    display: flex;
    justify-content: center;
    width: 100vw;
    padding-right: 380px;
  }
  
  /** Used to define the position of the ToastContainer **/
  .Toastify__toast-container--top-left {
  }
  .Toastify__toast-container--top-center {
  }
  .Toastify__toast-container--top-right {
  }
  .Toastify__toast-container--bottom-left {
  }
  .Toastify__toast-container--bottom-center {
    bottom:0;
  }
  .Toastify__toast-container--bottom-right {
  }
  
  /** Classes for the displayed toast **/
  .Toastify__toast {
    width: ${isMobileOnly?"84vw":"580px"};
    ${isMobileOnly?`
    padding: 12px 20px;
    `:`
    padding: 16px 20px;
    `};
    
    border-radius: 4px;
    background-color: #323232;  
    
    min-height: 0;
    margin-bottom: ${isMobileOnly?"70px":"100px"};
    font-size: 14px;
    
    text-align: center;
    color: #fff;
  }
  .Toastify__toast--rtl {
  }
  .Toastify__toast--dark {
  }
  .Toastify__toast--default {
  }
  .Toastify__toast--info {
  }
  .Toastify__toast--success {
  }
  .Toastify__toast--warning {
  }
  .Toastify__toast--error {
  }
  .Toastify__toast-body {
    font-family:  Montserrat, 'Noto Sans KR', sans-serif;
    margin:0;
    //line-height: 1.5em;
    line-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
  
    white-space: pre-line;
  }
  
  /** Classes for the close button. Better use your own closeButton **/
  .Toastify__close-button {
  }
  .Toastify__close-button--default {
  }
  .Toastify__close-button > svg {
  }
  .Toastify__close-button:hover, .Toastify__close-button:focus {
  }
  
  /** Classes for the progress bar **/
  .Toastify__progress-bar {
  }
  .Toastify__progress-bar--animated {
  }
  .Toastify__progress-bar--controlled {
  }
  .Toastify__progress-bar--rtl {
  }
  .Toastify__progress-bar--default {
  }
  .Toastify__progress-bar--dark {
  }
    `;

const Toast = ({type,msg,bottom}) => {

    return (
        <ToastWrapper>
            <ToastContainer style={bottom? {"marginBottom":bottom}:{}}/>
        </ToastWrapper>
    );
};

const ToastLeft = ({type,msg,bottom}) => {

  return (
      <ToastWrapperLeft>
          <ToastContainer style={bottom? {"marginBottom":bottom}:{}}/>
      </ToastWrapperLeft>
  );
};

const toastMsg = (type, msg) =>  {
    // const toastId = React.useRef(null);
    //연속으로 토스트 메시지 선택
    toast.dismiss();
    
    const toastId = "test";
    let options = {
        position: "bottom-center",
        autoClose: 2000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        closeButton: false,
        toastId: toastId
    };
    // !multiple&&(options["toastId"] = toastId);
    //console.log("toast active = " + toast.isActive(toastId))
    // 토스트 팝업 사라지기 전에 페이지 이동되면 토스트 팝업 다시 동작 안함.
    //if(! toast.isActive(toastId)) {
        toast(msg, options)
    //}
    //window.setTimeout(()=>{if(toast.isActive(toastId)) toast.dismiss();},2000)
}

// export default Toast;
export {Toast,toastMsg as toast, ToastLeft};
